(function () {
  'use strict';

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’'`´]/g, '')
      .replace(/[_\-–—/:]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function sanitizeDisplayPlate(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^\p{L}\p{N}\- ]/gu, '')
      .replace(/^\s+/, '')
      .replace(/ {2,}/g, ' ')
      .slice(0, 16);
  }

  function previewPlateValue(value) {
    return sanitizeDisplayPlate(String(value || '').split(',')[0]).trim().slice(0, 12);
  }

  function placeholder(locale) {
    return {
      nl: 'JOUW KENTEKEN',
      en: 'YOUR PLATE',
      de: 'IHR KENNZEICHEN',
      fr: 'VOTRE PLAQUE',
      it: 'LA TUA TARGA',
      pl: 'TWOJA TABLICA',
      cs: 'VAŠE SPZ',
      da: 'DIN NUMMERPLADE'
    }[locale] || 'JOUW KENTEKEN';
  }

  function getControlDescriptor(control) {
    const labels = control.labels ? Array.from(control.labels).map((label) => label.textContent || '').join(' ') : '';
    const wrapper = control.closest('.gpo-element, .globo-form-control, [class*="gpo-"], [class*="globo"], .product-form__input, .field, .uploadkit, [class*="uploadkit"]');
    const wrapperText = wrapper ? (wrapper.textContent || '').slice(0, 900) : '';
    const nodeText = (control.parentElement?.textContent || '').slice(0, 500);
    return normalizeText([
      control.name,
      control.id,
      control.getAttribute('aria-label'),
      control.getAttribute('placeholder'),
      control.getAttribute('title'),
      control.getAttribute('data-label'),
      labels,
      wrapperText,
      nodeText
    ].filter(Boolean).join(' '));
  }

  function findPlateInput(scope, root) {
    const candidates = Array.from(scope.querySelectorAll('input[type="text"], input:not([type]), textarea'))
      .filter((control) => !root.contains(control) && control.offsetParent !== null);

    let best = null;
    let bestScore = 0;
    candidates.forEach((control) => {
      const descriptor = getControlDescriptor(control);
      let score = 0;
      if (/\bkenteken\b|\bkennzeichen\b/.test(descriptor)) score += 120;
      if (/ingevoerde\s+kenteken|amtliches\s+kennzeichen/.test(descriptor)) score += 60;
      if (/licen[cs]e plate|registration plate|number plate/.test(descriptor)) score += 70;
      if (/plaat|plaque|plate/.test(descriptor)) score += 20;
      if (/properties/.test(descriptor)) score += 10;
      if (score > bestScore) {
        best = control;
        bestScore = score;
      }
    });

    return bestScore >= 70 ? best : null;
  }

  function findPreviewHost(scope) {
    const candidates = [
      scope.querySelector('.product__media-item.is-active .product-media-container'),
      scope.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
      scope.querySelector('.product-media-container'),
      document.querySelector('.product__media-item.is-active .product-media-container'),
      document.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
      document.querySelector('.product-media-container')
    ];
    return candidates.find(Boolean) || null;
  }

  function init(root) {
    if (root.dataset.gbEplatePreviewBound === '1') return true;
    const scope = root.closest('.shopify-section') || document;
    const plateInput = findPlateInput(scope, root);
    const host = findPreviewHost(scope);
    if (!plateInput || !host) return false;

    host.classList.add('gb-eplate-preview__host');

    let frame = host.querySelector('[data-gb-eplate-preview-frame]');
    let textNode = host.querySelector('[data-gb-eplate-preview-text]');
    if (!frame) {
      frame = document.createElement('div');
      frame.className = 'gb-eplate-preview__frame is-visible is-placeholder';
      frame.setAttribute('data-gb-eplate-preview-frame', '');
      frame.setAttribute('aria-hidden', 'true');
      textNode = document.createElement('span');
      textNode.className = 'gb-eplate-preview__text';
      textNode.setAttribute('data-gb-eplate-preview-text', '');
      frame.appendChild(textNode);
      host.appendChild(frame);
    }

    const locale = (root.dataset.locale || document.documentElement.lang || 'nl').toLowerCase().slice(0,2);

    function render(value) {
      const previewValue = previewPlateValue(value);
      const hasValue = Boolean(previewValue);
      textNode.textContent = hasValue ? previewValue : placeholder(locale);
      frame.classList.add('is-visible');
      frame.classList.toggle('is-placeholder', !hasValue);
      frame.classList.remove('is-medium', 'is-small');
      if (hasValue) {
        if (previewValue.length >= 12) frame.classList.add('is-small');
      }
    }

    plateInput.addEventListener('input', function () {
      const cleaned = sanitizeDisplayPlate(plateInput.value);
      if (cleaned !== plateInput.value) plateInput.value = cleaned;
      render(cleaned);
    });

    render(plateInput.value);
    root.dataset.gbEplatePreviewBound = '1';
    return true;
  }

  function boot() {
    const roots = document.querySelectorAll('[data-gb-eplate-preview]');
    roots.forEach((root) => {
      if (init(root)) return;
      let tries = 0;
      const interval = window.setInterval(() => {
        tries += 1;
        if (init(root) || tries > 40) window.clearInterval(interval);
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  const observer = new MutationObserver(() => boot());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
